
const useProjectMetaData = (autoProjectState, initialNewAutoProject) => {
    const handleOnBlurProjectName = async () => {
        (autoProjectState.isProjectInitialized === false && autoProjectState.projectName) && await initialNewAutoProject(autoProjectState.projectName);
    };

    return {handleOnBlurProjectName};
};

export default useProjectMetaData;
